import React from "react";
import RegoinCard from "./Services/RegoinCard";
import TourCategories from "./Services/ServiceCategories";
import InterestCard from "./Services/Interest";
import SpecialExplorer from "./Services/Special";
import Hero3 from "../../components/hero2/Hero3";
import TopCountry from "./Services/TopCountry";

const Home = () => {
  return (
    <div>
      {/* <HeroTour /> */}

      {/* Navigated menu start*/}
      {/* <nav class="bg-grey-light w-full rounded-md pl-20 pt-10">
        <ol class="list-reset flex">
          <li>
            <Link
              to={"/"}
              class="text-primary transition duration-150 ease-in-out hover:text-primary-600 focus:text-primary-600 active:text-primary-700 dark:text-primary-400 dark:hover:text-primary-500 dark:focus:text-primary-500 dark:active:text-primary-600"
            >
              Home
            </Link>
          </li>
          <li>
            <AiOutlineRight className="mt-1 mx-2" />
          </li>
          <li>
            <Link
              to={"#"}
              class="text-primary transition duration-150 ease-in-out hover:text-primary-600 focus:text-primary-600 active:text-primary-700 dark:text-primary-400 dark:hover:text-primary-500 dark:focus:text-primary-500 dark:active:text-primary-600"
            >
              Tour Packages
            </Link>
          </li>
          <li>
            <AiOutlineRight className="mt-1 mx-2" />
          </li>
          <li class="text-neutral-500 dark:text-neutral-400">
            Explore Gujrat
          </li>
        </ol>
      </nav> */}
      {/* Navigated menu end*/}

      {/* Navigation Tour bar */}

      {/* Categories */}
      <Hero3 />
      <div className="mx-auto max-w-2xl px-4  sm:px-6  lg:max-w-7xl lg:px-8">
        {/* welcome image */}
        {/* <img src={welcome} alt="" /> */}{" "}
        <h1 className="text-4xl mt-10 mb-10 ml-2">Popular Categories</h1>
        <TourCategories />
      </div>

      {/* <TourNav /> */}
      {/* Service Card Brief start */}
      <div className="mx-auto max-w-2xl px-4 pt-0 pb-16 sm:px-6 sm:pt-0 sm:pb-24 lg:max-w-7xl lg:px-8 mt-16">
      <h1 className="text-4xl mb-5 ml-2">
          Explore Top Destinations by Region
        </h1>
        <RegoinCard />
      </div>

      <div className="mx-auto max-w-2xl px-4 py-16 sm:px-6 sm:py-0 lg:max-w-7xl lg:px-8">
        {/* <h1 className="text-4xl mb-10 ml-2">
        Deals You Can't Miss
        </h1> */}
        <TopCountry />
      </div>

      <div className="mx-auto max-w-2xl px-4 py-16 sm:px-6 sm:py-20 lg:max-w-7xl lg:px-8">
        <h1 className="text-4xl mb-5 ml-2">Packages By Interest</h1>
        <InterestCard />
      </div>
      <div className="mx-auto max-w-2xl px-4 py-16 sm:px-6 sm:py-1 lg:max-w-7xl lg:px-8">
        <h1 className="text-4xl mb-5 ml-2">Special Offers Tours</h1>
        <SpecialExplorer />
      </div>
    </div>
  );
};

export default Home;
